import { AxiosRequest } from "../common/axios-request";
import {
  GET_ALL_SYSTEM_NOTIFICATION_TEMPLATES,
  UPDATE_SYSTEM_NOTIFICATION_TEMPLATE,
} from "../common/constant";

const GetAllSystemNotificationTemplates = () => {
  return AxiosRequest.get(GET_ALL_SYSTEM_NOTIFICATION_TEMPLATES);
};

const UpdateSystemNotificationTemplates = (id: string, payload: any) => {
  return AxiosRequest.put(
    UPDATE_SYSTEM_NOTIFICATION_TEMPLATE.replace(":id", id),
    payload
  );
};

export { GetAllSystemNotificationTemplates, UpdateSystemNotificationTemplates };
